import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import RichText from './RichText';
import { POPUP_ENABLED, POPUP_TESTING_MODE, popupConfig } from '../../data/general/popupData';
import './Popup.css';

const Popup = () => {
  const [open, setOpen] = useState(false);
  
  // Check if popup should be active (flag + date window)
  const hasPopup = popupConfig && POPUP_ENABLED;
  const { startDate, endDate } = popupConfig || {};
  const now = new Date();
  const starts = startDate ? new Date(startDate) : null;
  // Set end date to end of day (23:59:59.999) so popup shows through the entire day
  const ends = endDate ? new Date(new Date(endDate).setHours(23, 59, 59, 999)) : null;
  const activeByDate = (!starts || now >= starts) && (!ends || now <= ends);
  const isActive = hasPopup && activeByDate;
  
  // Handle popup timing logic
  useEffect(() => {
    if (!isActive) return; // Don't show if not active
    
    if (POPUP_TESTING_MODE) {
      setOpen(true); // Always show for testing
    } else {
      // 2-hour logic for production
      const lastPopupTime = localStorage.getItem('popupLastShown');
      const now = Date.now();
      const twoHours = 2 * 60 * 60 * 1000; // 2 hours in milliseconds

      if (!lastPopupTime || (now - parseInt(lastPopupTime)) > twoHours) {
        setOpen(true);
        localStorage.setItem('popupLastShown', now.toString());
      }
    }
  }, [isActive]);

  // Don't render if no popup is scheduled or popup system is disabled
  if (!isActive) {
    return null;
  }
  
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="popup-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="popup-popup"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            onClick={e => e.stopPropagation()}
          >
            <button 
              className="popup-close-button"
              onClick={() => setOpen(false)}
            >
              &times;
            </button>
            <h2 className="popup-title">
              {popupConfig.title}
            </h2>
            <RichText value={popupConfig.message} className="popup-text" />
            {popupConfig.formUrl && (
              <a
                className="popup-form-button"
                href={popupConfig.formUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {popupConfig.buttonText}
              </a>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Popup;